import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

export const telephoneAnchorLink = {
  color: palette.grey['50']
};

const styles: Record<string, SxProps> = {
  lineOnScrollLabel: {
    color: palette.grey.main,
    backgroundColor: palette.secondary.main,
    borderRadius: '0.25rem',
    padding: { xs: spacing(0.25), md: spacing(0.5) },
    textAlign: 'center',
    zIndex: '2'
  },

  animateOnScrollBox: {
    transform: 'translateX(80rem)',
    maxWidth: { xs: '16.5rem', md: '50rem' },
    width: '100%',
    mt: { xs: '0rem', md: 'none' },
    mb: '0',
    '& > div': {
      minHeight: { xs: '10rem', md: '12rem' }
    },
    transition: 'transform 1s ease-out'
  }
};

export default styles;
